import React, { useEffect } from 'react'
import InputTextField from 'src/components/common/form-elements/InputTextField'

interface MinOrderValueDialogProps {
  initialMinOv: number
  minOV: number
  setMinOV: (value: number) => void
  txnType: 'EARN' | 'BURN'
}

const MinOrderValueDialog: React.FC<MinOrderValueDialogProps> = ({ minOV, setMinOV, txnType, initialMinOv }) => {
  useEffect(() => {
    return setMinOV(initialMinOv)
  }, [])

  return (
    <div>
      <div className='flex flex-col items-start justify-between w-full'>
        <p className='text-sm font-medium text-coal-light'>
          {txnType === 'EARN' ? 'Minimum order value for earning rewards' : 'Minimum order value for credit redemption'}
        </p>
        <InputTextField
          inputValue={minOV || ''}
          textFieldId='min-ov'
          startIcon={<>₹</>}
          handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const enteredValue = event.target.value
            const numericValue = Number(enteredValue)
            if (numericValue < 0) {
              setMinOV(0)
              return
            }
            setMinOV(isNaN(numericValue) ? 0 : numericValue)
          }}
          inputPlaceholder={'No minimum value'}
          inputType='number'
          isFullWidth={true}
          customClass={'!w-fit'}
        />
      </div>
    </div>
  )
}

export default MinOrderValueDialog
